export const whatsappBanerData = {
  addClickFunc: true,
  banner:
    'https://images.myloapp.in/NestJsUploads/animated_webp/1732185679725-Lactomama-chat-3.webp',
};
export const lactoBannerData = {
  addClickFunc: false,
  banner:
    'https://images.myloapp.in/NestJsUploads/1731405302494-mweb-money-back-1.webp',
};
